/*
 * Copyright (c) 2020.
 * Simon
 */

import {
    TEMPLATE_CREATE_SUCCESS,
    TEMPLATE_DELETE_SUCCESS,
    TEMPLATE_DETAIL_SUCCESS,
    TEMPLATE_EDIT_SUCCESS,
    TEMPLATE_LIST_SUCCESS
} from "../../types";

/**
 * @param {*} state
 * @param {*} action
 */
const TemplatesReducer = (state = {}, action) => {
    if (action.payload === undefined || action.payload === false) return state;

    switch (action.type) {
        case TEMPLATE_LIST_SUCCESS:
            let templates = action.payload.data.data;

            templates.map((template) => {
                let id = template['id'];
                state[id] = template;
                return true;
            });

            return {...state, action};

        case TEMPLATE_EDIT_SUCCESS:
        case TEMPLATE_DELETE_SUCCESS:
        case TEMPLATE_DETAIL_SUCCESS:
        case TEMPLATE_CREATE_SUCCESS:
            let id = action.payload.data['id'];
            state[id] = action.payload.data;
            return {...state, action};
        default:
            return state;
    }
};

export {TemplatesReducer}